function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { Fragment } from "react";
import { createPortal } from "react-dom";
export function renderWithPortal(renderElement, portal) {
    if (portal === true) {
        return portalToBody(renderElement);
    }
    if (typeof portal === 'string') {
        return portalToId(renderElement, portal);
    }
    if (_instanceof(portal, Object)) {
        return portalToRef(renderElement, portal);
    }
    return renderElement;
}
export default renderWithPortal;
function portalToBody(renderElement) {
    return createPortal(renderElement, document.body);
}
function portalToId(renderElement, portal) {
    var portalElement = document.getElementById(portal);
    if (portalElement) {
        return createPortal(renderElement, portalElement);
    }
    return _jsx(Fragment, {});
}
function portalToRef(renderElement, portal) {
    if (portal.hasOwnProperty('current')) {
        if (_instanceof(portal.current, Element)) {
            return createPortal(renderElement, portal.current);
        }
    } else if (_instanceof(portal, Element)) {
        return createPortal(renderElement, portal);
    }
    return _jsx(Fragment, {});
}
